import { modal } from './modules/modal';
import { smooth } from './modules/smooth';
import { bnrAction } from './modules/bnr';
import { heroSlider, slider } from './modules/slider';
import { tableScroll } from './modules/tableScroll';
import { accordion } from './modules/accordion';

modal();
smooth();
bnrAction();
slider();
tableScroll();
heroSlider();
accordion();
